import { ACTION_SET_CONTRACT } from "./names.js";

export default function contractInfo(state = {}, action) {
  switch (action.type) {
    case ACTION_SET_CONTRACT:
      return action.payload;

    default:
      return state;
  }
}
